import { motion } from "framer-motion";

const education = [
  { year: "Expected 2026", label: "Executive MBA (Finance) — Rabindranath Tagore University, Bhopal" },
  { year: "2024", label: "PG Certificate, EV Design — IIT Roorkee" },
  { year: "2004", label: "Bachelor of Engineering (Mechanical) — Pune University" },
];

const certifications = [
  ["Project Management Professional (PMP®)", "PMI"],
  ["PMI Agile Certified Practitioner (PMI-ACP®)", "PMI"],
  ["Professional Scrum Master I & II", "Scrum.org"],
  ["Critical Chain Project Management", "CCPM"],
  ["Google Project Management Certificate", "Google"],
  ["Oracle Generative AI Project Management", "Oracle"],
  ["ISC2 Cyber Security Professional", "ISC2"],
  ["Leadership Program", "IIM Ahmedabad (Coursera)"],
  ["Project Management Programs", "Adelaide · Harvard (edX)"],
  ["Six Sigma — Black / Yellow / Green / White", "AIGPE"],
  ["Chartered Engineer (CEng)", "IEI"],
  ["Fellow of Institution of Engineers (FIE)", "IEI"],
];

const item = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1, y: 0,
    transition: { duration: 0.6, delay: i * 0.03, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function EducationCerts() {
  return (
    <section id="credentials" className="relative border-b border-surface-2 bg-[#0b1a30]">
      <div className="mx-auto max-w-[1440px] px-6 md:px-16 py-28 md:py-40">
        <div className="text-[11px] uppercase tracking-[0.28em] text-brass mb-10">
          <span className="tabular">12 —</span><span className="ml-3">Education & Certifications</span>
        </div>

        <div className="grid grid-cols-12 gap-10 md:gap-16">
          <div className="col-span-12 md:col-span-5">
            <h3 className="font-serif-display text-ivory text-3xl md:text-4xl font-light">
              Formal Education
            </h3>
            <div className="hairline mt-6 mb-2" />
            <ul>
              {education.map((e, i) => (
                <motion.li
                  key={e.label}
                  custom={i}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={item}
                  className="py-5 border-b border-surface-2"
                >
                  <div className="text-brass text-[11px] uppercase tracking-[0.22em] tabular">{e.year}</div>
                  <div className="mt-1 text-ivory font-light text-lg leading-snug">{e.label}</div>
                </motion.li>
              ))}
            </ul>
          </div>

          <div className="col-span-12 md:col-span-7">
            <h3 className="font-serif-display text-ivory text-3xl md:text-4xl font-light">
              Professional Certifications
            </h3>
            <div className="hairline mt-6" />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10">
              {certifications.map(([name, issuer], i) => (
                <motion.div
                  key={name}
                  custom={i}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={item}
                  className="py-4 border-b border-surface-2 flex items-baseline justify-between gap-4"
                >
                  <span className="text-ivory font-light">{name}</span>
                  <span className="text-mutedfg text-xs uppercase tracking-[0.18em] shrink-0">{issuer}</span>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
